module.exports = __webpack_public_path__ + "img/warning-moderate.405d9908.svg";